import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'export-dropdown',
  templateUrl: './export-dropdown.component.html',
  styleUrls: ['./export-dropdown.component.css']
})
export class ExportDropdownComponent implements OnInit {
  @Output() onSelectionChange: EventEmitter<void> = new EventEmitter<void>();
  @Input() ifGridHaveCheckBox: boolean;
  @Input() classForExportDropdownButton: any;
  @Input() disabled: boolean;

  constructor() { }

  ngOnInit(): void {
  } exportGrid(value: any) {
    // If trying to export selected rows (value 2 or 4) but no rows are selected, don't proceed
    if ((value === 2 || value === 4) && !this.ifGridHaveCheckBox) {
      return;
    }
    this.onSelectionChange.emit(value);
  }
}
